import Card from '@zenbusiness/zui/Card';
import CardHeader from '@zenbusiness/zui/CardHeader';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { styled, superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const Root = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column-reverse',
  backgroundColor: theme.palette.fixed.grey[950],
  gap: theme.spacing(3),
  padding: theme.spacing(3),
  borderRadius: theme.shape.rounded.xl,

  [theme.breakpoints.up('lg')]: {
    gap: theme.spacing(5),
    flexDirection: 'row',
    alignItems: 'center',
  },
}));

export const ContentContainer = styled(Stack)(({ theme, border }) => ({
  flex: 1,
  gap: theme.spacing(3),
  overflow: 'hidden',
  borderRadius: border && theme.shape.rounded.xl,
}));

export const Image = superstyled({
  name: 'ZuiHeaderImage',
  slot: 'Root',
  tag: SharedAsset,
  styles: ({ theme }) => ({
    width: '100%',
    minHeight: '8.875rem',
    borderRadius: theme.shape.rounded.xl,
    objectPosition: 'top',
    objectFit: 'cover',

    [theme.breakpoints.up('lg')]: {
      minHeight: '15rem',
      maxHeight: '19rem',
    },
  }),
});

export const Header = styled(CardHeader)(({ theme }) => ({
  gap: theme.spacing(1),

  [theme.breakpoints.up('lg')]: {
    gap: theme.spacing(2),
  },
}));

export const CardTitle = styled(Text)(() => ({
  textWrap: 'wrap',
}));

export const CardSubTitle = styled(Text)(({ theme }) => ({
  fontSize: '0.75rem',
  whiteSpace: 'pre-line',

  [theme.breakpoints.up('lg')]: {
    fontSize: '0.875rem',
  },
}));

export const IconContainer = styled(Stack)(({ theme }) => ({
  justifyContent: 'center',
  alignItems: 'center',
  width: '1.75rem',
  height: '1.75rem',
  backgroundColor: theme.palette.background.green.main,
  borderRadius: theme.shape.rounded.full,

  [theme.breakpoints.up('lg')]: {
    width: '2.25rem',
    height: '2.25rem',
  },
}));

export const Icon = styled(SharedAsset)(({ theme }) => ({
  width: '1rem',
  height: '1rem',

  [theme.breakpoints.up('lg')]: {
    width: '1.25rem',
    height: '1.25rem',
  },
}));

export const BulletList = styled('ul')(({ theme }) => ({
  paddingLeft: 36,
  listStyleType: 'disc',
  color: 'white',
  fontSize: '0.75rem',
  marginTop: theme.spacing(-2),

  [theme.breakpoints.up('lg')]: {
    fontSize: '0.875rem',
  },
}));

export const BulletItem = styled('li')(() => ({
  margin: 0,
}));
